exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvasMenu{cursor:default;position:absolute;z-index:200;display:block}.canvasMenu .submenu{list-style:none;margin:0;padding:6px 0;background-color:#fff;border:1px solid #009788;min-width:150px}.canvasMenu .submenu li{margin:0;color:#333;display:block;cursor:pointer;padding:5px 0;padding-right:10px;border:0;background-color:transparent}.canvasMenu .submenu li i{margin:0 18px}.canvasMenu .submenu li:hover{color:#009788;background-color:#f4fefd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-148241c8","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/yz-flow/src/canvasMenu.vue
// module id = 19
// module chunks = 0